import { CircularProgress, Stack, Typography } from "@mui/material";
import { useEffect, useState } from "react";

type Props = {
	isTotp?: boolean;
};

const ConfirmationTimer = ({ isTotp }: Props) => {
	const totalTime = 4 * 60 + 30;
	const [timeLeft, setTimeLeft] = useState(totalTime);

	useEffect(() => {
		const intervalId = setInterval(() => {
			setTimeLeft((prev) => {
				if (prev <= 1) {
					clearInterval(intervalId);
					return 0;
				}
				return prev - 1;
			});
		}, 1000);

		return () => clearInterval(intervalId);
	}, []);

	const minutes = Math.floor(timeLeft / 60);
	const seconds = timeLeft % 60;
	const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;
	const formattedSeconds = seconds < 10 ? `0${seconds}` : seconds;

	const progress = (timeLeft / totalTime) * 100;

	return (
		<Stack alignItems={"center"} sx={{ justifyContent: "center", mt: isTotp ? 4 : 0 }}>
			<Stack>
				<CircularProgress
					variant='determinate'
					value={100}
					size={80}
					thickness={2}
					sx={{
						color: "grey.300"
					}}
				/>
				<CircularProgress
					variant='determinate'
					value={progress}
					size={80}
					thickness={2}
					sx={{ position: "absolute", color: "primary.main" }}
				/>
			</Stack>

			<Typography
				variant='subtitle1'
				sx={{ position: "absolute" }}
			>{`${formattedMinutes}:${formattedSeconds}`}</Typography>
		</Stack>
	);
};

export default ConfirmationTimer;
